<template>
  <div class="s-stores-slick">
    <div class="page-container">
      <div v-if="records.length" class="small extrabold mb-24">
        {{ dictionary.placesLabel }}
      </div>

      <div v-if="percentage" class="s-stores-slick__progress-bar">
        <ProgressBar :percentage="percentage" />
      </div>

      <SlickCarousel
        ref="slick"
        :key="'key-' + slickKey"
        class="s-stores-slick__slick"
        :options="slickOptions"
        @init="onInit"
        @beforechange="onBeforeChange">
        <div
          v-for="item in records"
          :key="item.id"
          class="s-stores-slick__slide item">
          <Store :item="item" />
        </div>
      </SlickCarousel>
    </div>
  </div>
</template>

<script>
import * as lib from '../../lib/lib'
import ProgressBar from './../components/common/ProgressBar.vue'
import Store from '../components/Store.vue'
import SlickCarousel from './../components/common/SlickCarousel.vue'

export default {
  components: { ProgressBar, SlickCarousel, Store },

  data() {
    return {
      percentage: 0,
      records: [],
      slickKey: 0,
      slickOptions: {
        infinite: false,
        autoplay: false,
        arrows: true,
        dots: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        centerMode: false,
        responsive: [
          {
            breakpoint: 1200,
            settings: { slidesToShow: 3 },
          },
          {
            breakpoint: 992,
            settings: { slidesToShow: 2 },
          },
          {
            breakpoint: 768,
            settings: { slidesToShow: 1 },
          },
        ],
      },
    }
  },
  mounted() {
    const { records } = lib.getData('storesData')
    this.records = records
  },
  methods: {
    onInit(event, slick) {
      this.percentage = lib.getSlickProgressBarPercentage(slick)
    },
    onBeforeChange(event, slick) {
      setTimeout(() => {
        this.percentage = lib.getSlickProgressBarPercentage(slick)
      }, 100)
    },
  },
}
</script>
